import { AcceptedCountries } from '../international/internationalEnums';
import { CURRENCY_ISO, CURRENCY_SYMBOL, PAYMENT_METHOD_ID, PAYMENT_METHOD_NAME, PAYMENT_PROVIDER_ID } from './walletEnums';
import { BannedPaymentMethodsInCountry, Currency, WalletSettings } from './walletInterfaces';

const defaultDepositAmounts = [10, 20, 50];

export const GBP_MIN_DEPOSIT_AMOUNT = 5;

export const defaultWalletSettings: WalletSettings = {
  decimalPlaces: 2,
  defaultDeposits: defaultDepositAmounts,
  isoAlphabeticCode: CURRENCY_ISO.BRITISH_POUND,
  isoNumericCode: 826,
  maxDeposit: 10000,
  minDeposit: GBP_MIN_DEPOSIT_AMOUNT,
  minSportbookStake: 0.1,
  minWithdrawal: 5,
  name: 'Pound Sterling',
  symbol: CURRENCY_SYMBOL.POUND,
  createdAt: '2019-11-18T14:35:25.000Z',
  updatedAt: '2019-11-18T14:35:25.000Z',
  defaultStakes: [0.1, 0.2, 0.5, 1.0, 2.0, 5.0, 10.0, 20.0, 50.0, 100.0, 200.0, 500.0],
};

export const NUVEI_SOURCES = [2, 3, 4];

export const MAX_QUICK_METHODS_DISPLAYED_IF_NOT_FULL = 1;
export const MAX_QUICK_METHODS_DISPLAYED_IF_FULL = 3;

export const blackListedPaymentMethodsForFirstDeposit: BannedPaymentMethodsInCountry[] = [
  { country: AcceptedCountries.GREAT_BRITAIN, methodIds: [PAYMENT_METHOD_ID.PAYPAL] },
];

export const OTHER_PAYMENT_METHODS_ID = -1;

export const ZIMPLER_SIGNUP_PAYMENT_METHOD = {
  id: 301,
  logo: '',
  color: '',
  name: PAYMENT_METHOD_NAME.ZIMPLER,
  source: `${PAYMENT_PROVIDER_ID.ZIMPLER}`,
  reference: '',
  sourceReferenceId: 'zimpler_vsi',
};

export const TRANSACTIONS_HISTORY_MAX_DAYS_INTERVAL = 90;

export const PROFIT_AND_LOSS_MAX_MONTHS_IN_PAST = 3;

export const CURRENCY_LIST: Currency[] = [
  {
    currencyISO: CURRENCY_ISO.BRITISH_POUND,
    symbol: CURRENCY_SYMBOL.POUND,
    nameId: 'currency.name.GBP',
  },
  {
    currencyISO: CURRENCY_ISO.EURO,
    symbol: CURRENCY_SYMBOL.EURO,
    nameId: 'currency.name.EUR',
  },
  {
    currencyISO: CURRENCY_ISO.CANADIAN_DOLLAR,
    symbol: CURRENCY_SYMBOL.CANADIAN_DOLLAR,
    nameId: 'currency.name.CAD',
  },
  {
    currencyISO: CURRENCY_ISO.INDIAN_RUPEE,
    symbol: CURRENCY_SYMBOL.INDIAN_RUPEE,
    nameId: 'currency.name.INR',
  },
  {
    currencyISO: CURRENCY_ISO.KENYAN_SHILLING,
    symbol: CURRENCY_SYMBOL.KENYAN_SHILLING,
    nameId: 'currency.name.KES',
  },
  {
    currencyISO: CURRENCY_ISO.NEW_ZEALAND_DOLLAR,
    symbol: CURRENCY_SYMBOL.NEW_ZEALAND_DOLLAR,
    nameId: 'currency.name.NZD',
  },
  {
    currencyISO: CURRENCY_ISO.BRAZILIAN_REAL,
    symbol: CURRENCY_SYMBOL.BRAZILIAN_REAL,
    nameId: 'currency.name.BRL',
  },
  {
    currencyISO: CURRENCY_ISO.UNITED_STATES_DOLLAR,
    symbol: CURRENCY_SYMBOL.DOLLAR,
    nameId: 'currency.name.USD',
  },
  {
    currencyISO: CURRENCY_ISO.SWISS_FRANC,
    symbol: CURRENCY_SYMBOL.SWISS_FRANC,
    nameId: 'currency.name.CHF',
  },
];

export const CLOSED_LOOP_DETAILS_URL = 'https://kwiff.zendesk.com/hc/en-us/articles/21160562860177-Withdrawals-The-Net-Deposit-Rule';
